import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { alertSuccessForegroundGreen } from "Styling/Palette/AlertColours";
import { FunctionComponent } from "react";

const SuccessIcon: FunctionComponent = () => <MaterialUiIcons.CheckCircle htmlColor={alertSuccessForegroundGreen} />;

export default SuccessIcon;
